import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
  padding: 6rem 2.5rem;
  background: var(--dark);
  color: var(--white);
`;

const Inner = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
`;

const Left = styled(motion.div)``;

const Eyebrow = styled.p`
  font-size: 0.68rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--gray-3);
  font-weight: 500;
  margin-bottom: 1rem;
`;

const Heading = styled.h2`
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  color: var(--white);
  letter-spacing: -0.03em;
  line-height: 1.15;
  margin-bottom: 1rem;
`;

const Sub = styled.p`
  font-size: 0.92rem;
  color: var(--gray-3);
  line-height: 1.7;
  font-weight: 300;
`;

const Right = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 0.5rem;
`;

const ContactItem = styled.div``;

const ContactLabel = styled.p`
  font-size: 0.68rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--gray-3);
  margin-bottom: 0.35rem;
  font-weight: 400;
`;

const ContactValue = styled.a`
  font-size: 1rem;
  color: var(--white);
  text-decoration: none;
  font-weight: 400;
  transition: opacity 0.2s;

  &:hover { opacity: 0.7; }
`;

const ContactText = styled.p`
  font-size: 1rem;
  color: var(--white);
  font-weight: 400;
`;

const Contact = () => (
  <Section id="kontakt">
    <Inner>
      <Left
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <Eyebrow>Kontakt</Eyebrow>
        <Heading>Ta kontakt</Heading>
        <Sub>
          &Aring;pen for dialog om investeringer, samarbeid og nye muligheter.
        </Sub>
      </Left>
      <Right
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        <ContactItem>
          <ContactLabel>E-post</ContactLabel>
          <ContactValue href="mailto:post@andreassenkapital.no">
            post@andreassenkapital.no
          </ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>LinkedIn</ContactLabel>
          <ContactValue
            href="https://www.linkedin.com/in/martin-andreassen-895b2a290/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Martin Andreassen
          </ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Lokasjon</ContactLabel>
          <ContactText>Bergen, Norge</ContactText>
        </ContactItem>
      </Right>
    </Inner>
  </Section>
);

export default Contact;
